import { render, staticRenderFns } from "./DetailThread.vue?vue&type=template&id=321c069e"
import script from "./DetailThread.vue?vue&type=script&lang=js"
export * from "./DetailThread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports